// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bgh_a"};